import { Typography } from "@mui/material";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import { TkSearchFormListItem } from "../../type/componentsType/TkSearchForm";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const helpMessage1 = (
  <Typography>
    　業務に従事した日数が１０日以下の月は被共済職員期間とならない月となります。
    <br />
    　業務に従事した日数が１０日以下の職員がいる場合には、該当職員の該当月にチェックを入れてください。
  </Typography>
);

const helpMessage2 = (
  <Typography>
    　育児休業をとった職員、育児休業の終了日を変更する職員がいる場合には、「育休確認・登録」ボタンをクリックして、必要な情報を登録してください。
  </Typography>
);

const helpMessage3 = (
  <Typography>
    　退職予定の職員がいる場合には、該当職員の「退職（予定）日」欄に退職予定日を入力してください。
  </Typography>
);

const explain = (
  <>
    <br />
    １）「ならない月」を登録してください。
    <TkHelpIcon helpMessage={helpMessage1} />
    <br />
    ２）育児休業をとった職員、育児休業の終了日を変更する職員がいる場合に、登録してください。
    <TkHelpIcon helpMessage={helpMessage2} />
    <br />
    ３）退職予定の職員がいる場合に退職予定日を登録してください。
    <TkHelpIcon helpMessage={helpMessage3} />
    <br />
  </>
);

const searchFormList: TkSearchFormListItem[] = [
  {
    label: "氏名",
    keyword: "name",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
];

const searchFormSchema = {
  name: {
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

const selectPropsListData = [
  {
    value: "2",
    label: "退職",
  },
  {
    value: "8",
    label: "継続異動減",
  },
  {
    value: "10",
    label: "合算申出減",
  },
];

export { explain, searchFormList, searchFormSchema, selectPropsListData };
